export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref6348.9d9ec88f.jpg";